import {createStore, applyMiddleware, combineReducers, compose} from 'redux';
import thunk from 'redux-thunk';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import layoutReducer from './layout';
import agentReducer from './agentState';
import agentConfig from './agentConfiguration';
import queueCalls from './queueCalls';
import callData from './callData';
import leadData from './leadData';
import breakReason from './breakReason';
import agentDial from './agentDial';
import agentNotes from './agentNotes';
import agentDisconnect from './agentDisconnect';
import agentHold from './agentHold';
import agentMode from './agentMode';
import agentBreak from './agentBreak';
import callTransfer from './callTransfer';
import customerDetails from './customerDetails';
import leadComment from './leadComments';
import agentConf from './agentConference';
import callDisp from './callDisposition';
import agentNotification from './agentNotification';
import manualLead from "./dialLead";
import agentReset from "./agentReset";
import callHistory from "./callHistory";
import callParking from "./parkCalls"
import callAgentHistory from "./callAgentHistory"

//const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  storage,
};

const agentData = persistReducer(persistConfig, agentReducer);
const layout = persistReducer(persistConfig, layoutReducer);

const reducer = combineReducers({
  layout: layout,
  agentData: agentData,
  agentConfig: agentConfig,
  queueCalls: queueCalls,
  callData: callData,
  leadData: leadData,
  breakReason: breakReason,
  agentDial: agentDial,
  agentDisconnect: agentDisconnect,
  agentHold: agentHold,
  callTransfer: callTransfer,
  customerDetails: customerDetails,
  leadComment:leadComment,
  agentConf: agentConf,
  callDisp: callDisp,
  agentMode: agentMode,
  agentBreak: agentBreak,
  agentNotes: agentNotes,
  agentNotification: agentNotification,
  manualData :  manualLead,
  resetData: agentReset,
  callHistory: callHistory,
  callParking:callParking,
  callAgentHistory: callAgentHistory
});

export let store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));
export let persistor = persistStore(store);

/*const configureStore = () => {
  return {
    ...createStore(reducer, composeEnhancers(applyMiddleware(thunk))),
  };
};

export default configureStore;*/
